/**
 * Created by RSchweber-Koren on 4/26/2017.
 */
/*
 * Takes a numeric calendar id and turns it into a string of the form "tb-calendar-event-[id}
 * Used by the calendar display directives to create the anchor tags that allow for scrolling to the event.
 *
 * Angular Module: "trackerbase-app.filters.calendar-event-id-format-filter"
 * Filter exposed as: tbCalendarEventIdFormat
 *
 */

import angular from "angular";

function calendarEventIdFormatFilterFactory() {

    function calendarEventIdFormatFilter(eventId) {
        if (!(Number.isInteger(eventId))) {
            return undefined;
        }

        return `tb-calendar-event-${eventId}`;
    }

    return calendarEventIdFormatFilter;
}

calendarEventIdFormatFilterFactory.$inject = [];

export default angular
    .module("trackerbase-app.filters.calendar-event-id-format-filter", [
    ])
    .filter("tbCalendarEventIdFormat", calendarEventIdFormatFilterFactory)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/filters/CalendarEventIdFormatFilter.js
// module id = i3Kh
// module chunks = 1